import React, { ReactElement, useState } from 'react'
import styled from 'styled-components'
import {
  SelectField,
  enumToOptions,
  SubCategoryFormat,
  capitalize,
  alertSuccess,
  ISelectOption,
  alertError,
  Loading,
  colors,
} from '@one-tree/library'
import { patchOrganisation } from '../../../helpers/APIHelper'
import { useOrganisation } from '../../../context/OrganisationProvider'

const Styles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 600px;
  margin-bottom: 30px;
`
export default function SubCategory(): ReactElement {
  const [loading, setLoading] = useState(false)
  const { organisation, saveOrganisation } = useOrganisation()

  const save = async (
    option: ISelectOption<SubCategoryFormat> | null,
  ): Promise<void> => {
    if (!organisation) return
    setLoading(true)

    const res = await patchOrganisation({
      organisationId: organisation.id,
      patchOptions: { subCategoryFormat: option ? option.value : undefined },
    })

    if (res && res.subCategoryFormat) {
      saveOrganisation(res)
      alertSuccess('Sub-category layout saved')
    } else {
      alertError('Error saving sub-category layout')
    }

    setLoading(false)
  }

  return (
    <Styles>
      <h3>Sub-category display format</h3>
      <p>
        This defines how sub-categories are displayed in your web shop.
        &apos;Row&apos; works well for a small number, but if you have lots of
        sub-categories, &apos;Grid&apos; or &apos;List&apos; is recommended.
      </p>
      <SelectField
        disabled={loading}
        options={enumToOptions(SubCategoryFormat)}
        label="Format"
        onChange={save}
        value={{
          value: organisation?.subCategoryFormat || SubCategoryFormat.Row,
          label: loading ? (
            <Loading
              style={{
                transform: 'scale(0.8)',
                marginTop: '1px',
                marginLeft: '-10px',
              }}
              spinnerColor={colors.darkerGray}
            />
          ) : (
            capitalize(organisation?.subCategoryFormat)
            || capitalize(SubCategoryFormat.Row)
          ),
        }}
      />
    </Styles>
  )
}
